import { Draft } from '@/dashboard/types/draft';
import { IS_DEVELOPMENT } from '@/dashboard/constants/app';

export type SimCase = 'owner' | 'member' | 'anon' | 'no-workspace';

const CASES: SimCase[] = ['owner', 'member', 'anon', 'no-workspace'];

function readSimCase(): SimCase | null {
  if (!IS_DEVELOPMENT) return null;

  const value = new URLSearchParams(window.location.search).get('sim');

  return CASES.includes(value as SimCase) ? (value as SimCase) : null;
}

/**
 * Позволяет посмотреть все состояния крошек, не перелогиниваясь под разными
 * аккаунтами: ?sim=owner | member | anon | no-workspace
 *
 * Подменяется только то, от чего зависит отрисовка крошек — id зрителя и поля
 * воркспейса. Права при этом не трогаются: доступ к самому драфту как проверялся
 * на бэкенде, так и проверяется. Вне development/staging хук всегда выключен.
 */
export function useBreadcrumbsSim() {
  const simCase = readSimCase();

  if (simCase) {
    // eslint-disable-next-line no-console
    console.info(`[DraftHeader] симуляция крошек: ${simCase}`);
  }

  function viewerId(realViewerId: number, draft: Draft | null): number {
    if (!simCase || !draft) return realViewerId;

    if (simCase === 'anon') return 0;
    if (simCase === 'member') return draft.owner_id + 1;

    return draft.owner_id;
  }

  function draftView(draft: Draft | null): Draft | null {
    if (!simCase || !draft || simCase !== 'no-workspace') return draft;

    return { ...draft, workspace_id: undefined, workspace_name: undefined, workspace_short_link: undefined };
  }

  return { simCase, viewerId, draftView };
}
